module.exports = __webpack_public_path__ + "static/img/battery_75.17c2d912.svg";